<div
  class="sidebar-scroll h-full overflow-y-auto py-2"
  [class.sidebar-scroll-collapsed]="collapsed"
>
  @if (collapsed) {
    <div class="sidebar-icon-groups">
      @for (group of groups; track group.id) {
        <div class="sidebar-icon-group-collapsed">
          @for (menuItem of group.items; track menuItem.id) {
            <button
              type="button"
              pRipple
              class="sidebar-icon-button app-button-motion-self app-button-motion-self-solid app-button-motion-trigger motion-safe-transition"
              [class.sidebar-icon-button-active]="menuItem.isActive"
              [class.sidebar-nav-button-disabled]="menuItem.disabled"
              [attr.aria-current]="menuItem.isActive ? 'page' : null"
              [attr.aria-disabled]="menuItem.disabled ? 'true' : null"
              [pTooltip]="menuItem.label"
              tooltipPosition="right"
              [disabled]="menuItem.disabled"
              (click)="selectItem(menuItem)"
            >
              <div
                class="sidebar-nav-icon motion-safe-transition"
                [class.sidebar-nav-icon-active]="menuItem.isActive"
              >
                <app-sidebar-icon
                  [icon]="menuItem.icon || 'pi pi-folder'"
                  class="sidebar-nav-icon-glyph"
                  [class.sidebar-nav-icon-glyph-active]="menuItem.isActive"
                />
              </div>
            </button>
          }
          @if (isSystemGroup(group.id)) {
            <div class="sidebar-theme-picker-slot sidebar-theme-picker-slot-collapsed">
              <app-sidebar-theme-picker [collapsed]="true" />
            </div>
          }
          <div class="sidebar-icon-divider"></div>
        </div>
      }
    </div>
  } @else {
    <div class="sidebar-groups">
      @for (group of groups; track group.id) {
        <section class="sidebar-group">
          @if (group.label) {
            <h3 class="sidebar-group-label">
              {{ group.label }}
            </h3>
          }

          <div class="sidebar-group-items">
            @for (item of group.items; track item.id) {
              <div
                class="sidebar-nav-item app-button-motion-trigger motion-safe-transition"
                [class.sidebar-nav-item-active]="item.isActive"
              >
                <button
                  type="button"
                  class="sidebar-nav-trigger motion-safe-transition"
                  [class.sidebar-nav-trigger-active]="item.isActive"
                  [class.sidebar-nav-button-disabled]="item.disabled"
                  [attr.aria-current]="isCurrentPage(item) ? 'page' : null"
                  [attr.aria-disabled]="item.disabled ? 'true' : null"
                  [disabled]="item.disabled"
                  (click)="selectItem(item)"
                >
                  <div
                    class="sidebar-nav-icon app-button-motion-target app-button-motion-target-solid motion-safe-transition"
                    [class.sidebar-nav-icon-active]="item.isActive"
                  >
                    <app-sidebar-icon
                      [icon]="item.icon || 'pi pi-folder'"
                      class="sidebar-nav-icon-glyph"
                      [class.sidebar-nav-icon-glyph-active]="item.isActive"
                    />
                  </div>
                  <span class="sidebar-nav-label" [class.sidebar-nav-label-active]="item.isActive">
                    {{ item.label }}
                  </span>
                </button>

                @if (item.subItems?.length && item.isActive) {
                  <div class="sidebar-sub-items">
                    @for (subItem of item.subItems; track subItem.id) {
                      <button
                        type="button"
                        pRipple
                        class="sidebar-sub-item motion-safe-transition"
                        [class.sidebar-sub-item-active]="subItem.isActive"
                        [class.sidebar-nav-button-disabled]="subItem.disabled"
                        [attr.aria-current]="isCurrentPage(subItem) ? 'page' : null"
                        [attr.aria-disabled]="subItem.disabled ? 'true' : null"
                        [disabled]="subItem.disabled"
                        (click)="selectItem(subItem)"
                      >
                        <span>{{ subItem.label }}</span>
                      </button>
                    }
                  </div>
                }
              </div>
            }

            @if (isSystemGroup(group.id)) {
              <div class="sidebar-theme-picker-slot">
                <app-sidebar-theme-picker />
              </div>
            }
          </div>
        </section>
      }
    </div>
  }
</div>
